import { dateFormat } from "util/commAction";

export const getDateInf = (now: Date) => {
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const date = now.getDate();
  const day = now.getDay(); // day = 6 (토요일) day = 0 (일요일)
  const fdate = new Date(`${year}/${month}/1`); // current  month first date
  const ldate = new Date(year, month, 0).getDate(); // current month last date
  const lmldate = new Date(year, month - 1, 0).getDate(); // last month last date
  const fday = fdate.getDay(); // current month first day
  const yearSt = year + "";
  const monthSt = ("00" + month).slice(-2);
  const dateSt = ("00" + date).slice(-2);
  const today =
    year.toString() +
    month.toString().padStart(2, "0") +
    date.toString().padStart(2, "0");
  const tomorrow =
    year.toString() +
    month.toString().padStart(2, "0") +
    (date + 1).toString().padStart(2, "0");

  return {
    now,
    year,
    yearSt,
    month,
    monthSt,
    date,
    dateSt,
    day,
    fdate,
    ldate,
    lmldate,
    fday,
    today,
    tomorrow,
  };
};

type IDateInf = {
  now: Date;
};

export const getCalendarInf = ({ now }: IDateInf) => {
  const { year, month, date, day, fdate, ldate, lmldate, fday } =
    getDateInf(now);

  const current = new Date();
  const today =
    current.getFullYear() +
    ("00" + (current.getMonth() + 1).toString()).slice(-2) +
    ("00" + current.getDate().toString()).slice(-2);

  let lastMonth = [];
  let currentMonth = [];
  let nextMonth = [];
  let monthDate = [];

  for (let i = 0; i < fday; i++) {
    const date = lmldate - fday + i + 1;
    lastMonth.push({ month: month - 1, date: "", dateSt: "", isLast: true });
  }

  for (let i = 1; i <= ldate; i++) {
    let isNow = new Date(year, month - 1, i);
    let isMonth = ("00" + (isNow.getMonth() + 1)).slice(-2);
    const isDate = ("00" + i.toString()).slice(-2);

    currentMonth.push({
      month,
      date: i,
      isCurrent: true,
      day: isNow.getDay(),
      dateSt: `${year}${isMonth}${isDate}`,
      isLast: Number(today) - Number(`${year}${isMonth}${isDate}`) > 0,
      isWeekStart: isNow.getDay() === 0,
      isWeekEnd: isNow.getDay() === 6,
      isFdate: i === 1,
      isLdate: i === ldate,
    });
  }

  for (let i = 0; i < 42 - ldate - fday; i++) {
    nextMonth.push({
      month: month + 1,
      date: i + 1,
      dateSt: "",
    });
  }

  monthDate = [...lastMonth, ...currentMonth];
  return { year, month, day, monthDate };
};

type IDateRange = {
  startDateStr: string;
  endDateStr: string;
  direction: "up" | "down";
};

export function getDatesRange({
  startDateStr,
  endDateStr,
  direction = "down",
}: IDateRange) {
  // 날짜 문자열을 Date 객체로 변환 (yyyy-mm-dd 형식)

  const startDate = new Date(dateFormat(startDateStr));
  const endDate = new Date(dateFormat(endDateStr));

  const dates = [];

  if (direction === "down") {
    // 시작 날짜부터 끝 날짜까지 반복
    while (startDate <= endDate) {
      // 날짜 배열에 추가 (YYYY-MM-DD 형식)

      dates.push(startDate.toISOString().split("T")[0].replaceAll("-", ""));
      startDate.setDate(startDate.getDate() + 1); // 하루씩 증가
    }
    return dates;
  }
  if (direction === "up") {
    while (endDate <= startDate) {
      // 날짜 배열에 추가 (YYYY-MM-DD 형식)

      dates.push(endDate.toISOString().split("T")[0].replaceAll("-", ""));
      endDate.setDate(endDate.getDate() + 1); // 하루씩 증가
    }
    // return dates.reverse();
    return dates;
  }

  // return dates;
}

export const getMonthList = (num: number) => {
  const now = new Date();

  const thisMonth = [];

  for (let i = 0; i <= num; i++) {
    const month = new Date(now.getFullYear(), now.getMonth() + i, 1);
    thisMonth.push(month);
  }

  return thisMonth;
};
